/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/



const validatePostalCode = (value) => {
  if (value == null || value === '') return true;

  /* check to see if the value matches any of our supported postal code formats */

  const regexPatterns = [
    /* US ZIP Code */
    '^\\b\\d{5}\\b(?:[- ]{1}\\d{4})?$',

    /* Canadian Postal Code - https://stackoverflow.com/a/46761018 */
    '^[ABCEGHJ-NPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ -]?\\d[ABCEGHJ-NPRSTV-Z]\\d$'
  ];

  if (regexPatterns.some(regex => new RegExp(regex).test(value))) {
    return true;
  }

  return 'Must enter a valid postal code.';
};



export default validatePostalCode;
